export function getUserType(user) {
  let type = '';
  if (user?.student) {
    type = 'student';
  } else if (user?.teacher) {
    type = 'teacher';
  } else if (user?.admin) {
    type = 'admin';
  }
  return type;
}
